import { useAppState } from 'src/state';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs'

export function SuperAdminThreadBreadCrumb({}:BreadcrumbComponentProps): React.ReactElement {
    const { currentItem } = useAppState().threads
    if (!currentItem) return <span>Thread</span>;
    return (
        <span>{`${currentItem.thread_type.display}`}</span>
    );
}